import React, { useEffect, useReducer } from 'react';
import API from '../../../../api/axios';
import StripedTable from '../../../../components/Table/StripedTable';
import Loading from '../../../../components/OtherElements/Loading';
import FullCard from '../../../../components/Card/FullCard';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Dialog from '../../../../components/Dialog/DefaultDialog';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import useTitle from 'hooks/useTitle';

function Loads(props) {
  useTitle('وضعیت بارگیری');
  // ---- Const and Variables: ----

  const thArray = ['عنوان', 'درصد موثر', 'ویرایش'];
  const initialState = {
    loads: [],
    isLoaded: false,
    fields: {
      addLoad: '',
      addLoadPercent: '',
      editLoad: '',
      editLoadPercent: '',
    },
    edit: {
      load: {
        id: '',
        title: '',
        percentAffected: '',
      },
    },
    modal: false,
  };

  const [state, dispatch] = useReducer(reducer, initialState);

  // ---- Functions and inline functions ----

  function reducer(state, action) {
    const oldFields = state.fields;
    switch (action.type) {
      case 'LOADING':
        return { ...state, isLoaded: false };
      case 'LOADED':
        return { ...state, isLoaded: true };
      case 'LOADS':
        return { ...state, loads: action.payload, isLoaded: true };
      case 'ADD_LOAD_FIELD':
        return { ...state, fields: { ...oldFields, addLoad: action.payload } };
      case 'EDIT_LOAD_FIELD':
        return { ...state, fields: { ...oldFields, editLoad: action.payload } };
      case 'ADD_LOAD_PERCENT':
        return {
          ...state,
          fields: { ...oldFields, addLoadPercent: action.payload },
        };
      case 'EDIT_LOAD_PERCENT':
        return {
          ...state,
          fields: { ...oldFields, editLoadPercent: action.payload },
        };
      case 'SHOW_MODAL':
        return {
          ...state,
          modal: true,
          fields: {
            ...oldFields,
            editLoad: action.payload.title,
            editLoadPercent: action.payload.percentAffected,
          },
          edit: {
            load: action.payload,
          },
        };
      case 'CLOSE_MODAL':
        return { ...state, modal: false };
      default:
        return { ...state };
    }
  }

  function searchQuery() {
    API('/api/v1/admin/load/type/list/', {
      method: 'get',
    })
      .then((res) => {
        dispatch({ type: 'LOADS', payload: res.data });
      })
      .catch((er) => {
        console.error(er);
      });
  }
  const handleShowModal = (id) => {
    const toEditLoad = state.loads.find((load) => load._id === id);
    const { title, percentAffected } = toEditLoad;
    const load = {
      id,
      title,
      percentAffected,
    };
    dispatch({ type: 'SHOW_MODAL', payload: load });
  };

  const handleClose = () => {
    dispatch({ type: 'CLOSE_MODAL' });
  };
  const handleEditLoad = () => {
    API(`/api/v1/admin/load/type/${state.edit.load.id}`, {
      method: 'put',
      data: {
        title: state.fields.editLoad,
        percentAffected: state.fields.editLoadPercent,
      },
    })
      .then((res) => {
        const msg = `محموله ${state.fields.editLoad} با موفقیت ویرایش شد.`;
        props.showMessage(1, 'bl', 'ویرایش', msg);
        searchQuery();
        dispatch({ type: 'CLOSE_MODAL' });
      })
      .catch((er) => {
        if (er.response) {
          props.showMessage(3, 'bl', 'خطا', 'بروز خطا غیر منتظره');
          console.error(`خطا منطقی: ${JSON.stringify(er.response)}`);
        } else {
          console.error(er);
        }
      });
  };
  const handleAddLoad = () => {
    API('/api/v1/admin/load/type', {
      method: 'post',
      data: {
        title: state.fields.addLoad,
        percentAffected: state.fields.addLoadPercent,
      },
    })
      .then((res) => {
        const msg = `محموله ${state.fields.addLoad} با موفقیت اضافه شد.`;
        props.showMessage(1, 'bl', 'افزودن محموله', msg);
        searchQuery();
      })
      .catch((er) => {
        const erMsg = `محموله با عنوان  ${state.fields.addLoad} از قبل موجود است.`;
        props.showMessage(3, 'bl', 'خطا', erMsg);
        console.error(`Add Load Error: ${JSON.stringify(er.response)}`);
      });
  };
  const handleDeleteLoad = (e) => {
    e.preventDefault();
    const { id, title } = e.target.dataset;
    dispatch({ type: 'LOADING' });
    API(`/api/v1/admin/load/type/${id}`, {
      method: 'delete',
    })
      .then((res) => {
        props.showMessage(
          1,
          'bl',
          'حذف',
          `محموله با عنوان ${title} با موفقیت حذف گردید.`
        );
        searchQuery();
      })
      .catch((er) => {
        console.error(er);
      });
  };

  useEffect(() => {
    searchQuery();
  }, []);

  // ---- Page elements and Rendering ... ----

  const loadsTable = state.isLoaded ? (
    <div className="loads-table">
      <StripedTable
        thArray={thArray}
        tdArray={state.loads.map((load) => {
          return [
            <span>{load.title}</span>,
            <span>
              {`${!!load.percentAffected ? load.percentAffected : 0} %`}
            </span>,
            <IconButton onClick={() => handleShowModal(load._id)}>
              <EditIcon />
            </IconButton>,
          ];
        })}
      />
    </div>
  ) : (
    <Loading />
  );

  const editForm = (
    <>
      <Grid
        container
        direction="column"
        justify="flex-start"
        alignItems="stretch"
        spacing={2}
      >
        <Grid item>
          <TextField
            value={state.fields.editLoad}
            onChange={(e) => {
              dispatch({ type: 'EDIT_LOAD_FIELD', payload: e.target.value });
            }}
            variant="outlined"
            fullWidth
            label="عنوان وضعیت بارگیری"
          />
        </Grid>
        <Grid item>
          <TextField
            value={state.fields.editLoadPercent}
            onChange={(e) => {
              dispatch({ type: 'EDIT_LOAD_PERCENT', payload: e.target.value });
            }}
            variant="outlined"
            fullWidth
            type="number"
            label="درصد موثر در کرایه وضعیت بارگیری"
          />
        </Grid>
      </Grid>
    </>
  );

  const body = (
    <>
      <Dialog
        open={state.modal}
        onSave={handleEditLoad}
        onClose={handleClose}
        title="ویرایش وضعیت بارگیری"
      >
        {editForm}
      </Dialog>
      <FullCard
        title={props.config.name}
        category="لیست انواع محموله و درصد موثر هر محموله در کرایه بار"
      >
        {loadsTable}
      </FullCard>
    </>
  );

  return body;
}
export default Loads;
